import React from 'react'
import { Document, Page, Image } from '@react-pdf/renderer';
import gastos from './gastos.jpg'

function PDF() {
  
  return (
    <Document>
        <Page size='A5'>
            <Image src={gastos} alt='perro'/>
        </Page>
    </Document>
  )
}

export default PDF